<!--
 * @Descripttion: 
 * @Author: luoyang
 * @Date: 2021-11-29 17:22:03
 * @LastEditors: luoyang
 * @LastEditTime: 2021-11-30 14:40:03
-->
<template>
  <!-- 主要功能 -->
  <div class="key_feature-mb">
    <div class="mobile-container">
      <h1 class="partH1" ref="HeaderTitle">主要功能</h1>
      <ul ref="ul" class="mb_feature_ul_bg">
        <li v-for="(item,i) in keyFeature.part1" :key="i" class="feature_bg" :style="{background: 'url('+item.bg+')' }">
          <div class="feature_title"><span>{{item.title}}</span></div>
          <div class="feature_info_bg">
            <div class="feature_info">{{item.info}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
// import animationUtils from "@/utils/animationUtils.js";
// import animationIndex from "@/utils/animationIndex.js";

export default {
  props: {
    keyFeature: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.key_feature-mb {
  margin-top: 284px;
  background: #f9f9f9;
  padding-bottom: 213px; //284-71
  .partH1 {
    width: 1720px;
    height: 180px;
    line-height: 180px;
    font-size: 156px;
    font-weight: 600;
    padding: 284px 0 174px;
    box-sizing: content-box;
    color: #000000;
  }
  .mb_feature_ul_bg {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .feature_bg {
      width: 853px;
      height: 853px;
      border-radius: 50%;
      margin-bottom: 71px;
      overflow: hidden !important;
      .feature_title {
        font-size: 85px;
      }
      .feature_info {
        font-size: 64px;
      }
      /* 第1、3、5个子元素 */
      &:nth-child(2n + 1) {
        /* 取消左负边距 */
        margin-right: 71px;
      }
      &:active {
        .feature_title {
          /* height: 0; */
          transition: all 0.5s;
          /* opacity: 0; */
        }
        .feature_info_bg {
          opacity: 0.9;
          transition: opacity 0.3s ease-in-out;
          border-radius: 50%;
        }
        .feature_info {
          top: 0;
          transition: top 0.6s ease-in-out;
        }
        .feature_title {
          span {
            top: 30px;
            transition: top 0.6s ease-in-out;
            opacity: 0;
          }
        }
      }
    }
  }
}
</style>